import { styled } from '@mui/material';
import { hexadecimal } from '../../utils/stringUtils';
import React from 'react';

const AnimationDotContainer = styled('div')(
  ({
    size,
    topOffset,
    rightOffset,
    dotColor,
  }: {
    size: number;
    topOffset: number;
    rightOffset: number;
    dotColor: string;
  }) => ({
    ':after': {
      animation: `shadow-pulse__RutlBg 4s infinite`,
      backgroundColor: dotColor,
      borderRadius: '50%',
      content: '""',
      display: 'block',
      height: `${size}px`,
      width: `${size}px`,
      position: 'absolute',
      right: `${rightOffset}px`,
      top: `${topOffset}px`,

      '@keyframes  shadow-pulse__RutlBg': {
        '0%': { boxShadow: `0 0 0 0 ${hexadecimal(dotColor)(50)}` },
        '50%': { boxShadow: `0 0 0 0 ${dotColor}` },
        '100%': { boxShadow: `0 0 0 ${size}px transparent` },
      },
    },
  }),
);

export const AnimationDot = ({
  animationDot,
  dotSize,
  topOffset,
  rightOffset,
  dotColor,
}: {
  animationDot: boolean;
  dotSize: number;
  topOffset: number;
  rightOffset: number;
  dotColor: string;
}) => {
  if (!animationDot) return null;

  return (
    <AnimationDotContainer
      size={dotSize}
      topOffset={topOffset}
      rightOffset={rightOffset}
      dotColor={dotColor}
    ></AnimationDotContainer>
  );
};
